var y = Object.defineProperty;
var k = (e, n, a) => n in e ? y(e, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[n] = a;
var t = (e, n, a) => k(e, typeof n != "symbol" ? n + "" : n, a);
function gt() {
  var e;
  try {
    return typeof ((e = window == null ? void 0 : window.mixpanel) == null ? void 0 : e.get_distinct_id) == "function" ? window.mixpanel.get_distinct_id() : void 0;
  } catch (n) {
    console.error(n);
    return;
  }
}
function w() {
  var e, n;
  return typeof window < "u" && ((n = (e = window.location) == null ? void 0 : e.hostname) == null ? void 0 : n.indexOf("hs-app.local.hsenv.io")) >= 0;
}
function b() {
  return typeof window < "u" && !!window.__STORYBOOK_API__;
}
function h(e) {
  var n;
  return w() ? `${e}${((n = window.hsGlobal) == null ? void 0 : n.mixpanelSuffix) ?? ""}` : e;
}
const T = {
  identify: (e) => {
    console.log("@helpscout/analytics identify:", e);
  },
  reset: () => {
    console.log("@helpscout/analytics reset");
  },
  track: (e, n) => {
    console.log("@helpscout/analytics track:", e, n);
  }
}, I = {
  identify: () => {
  },
  reset: () => {
  },
  track: () => {
  }
};
function c() {
  var e;
  return typeof window < "u" && typeof ((e = window.mixpanel) == null ? void 0 : e.track) == "function" ? window.mixpanel : O();
}
function O() {
  return w() || b() ? T : I;
}
const P = 3e3, R = 50, _ = 500, M = 6, D = 1e3, V = "hs-mixpanel-flag-overrides", u = "hs-mixpanel-flag-cache", l = /* @__PURE__ */ new Map();
U();
let r = null;
function S(e) {
  if (typeof window > "u") return null;
  try {
    const n = window.localStorage.getItem(V);
    if (!n) return null;
    const a = JSON.parse(n), o = a == null ? void 0 : a[e];
    return typeof o == "boolean" || typeof o == "string" ? o : null;
  } catch {
    return null;
  }
}
function U() {
  if (!(typeof window > "u"))
    try {
      const e = window.sessionStorage.getItem(u);
      if (!e) return;
      const n = JSON.parse(e);
      for (const [a, o] of Object.entries(n))
        (typeof o == "boolean" || typeof o == "string") && l.set(a, o);
    } catch {
    }
}
function F(e, n) {
  if (!(typeof window > "u"))
    try {
      const a = window.sessionStorage.getItem(u), o = a ? JSON.parse(a) : {};
      o[e] = n, window.sessionStorage.setItem(u, JSON.stringify(o));
    } catch {
    }
}
async function B(e = P) {
  var a, o, i;
  if (typeof window > "u") return !1;
  const n = Date.now();
  for (; typeof ((o = (a = window.mixpanel) == null ? void 0 : a.flags) == null ? void 0 : o.get_variant_value) != "function"; ) {
    const d = Date.now() - n;
    if (typeof ((i = window.mixpanel) == null ? void 0 : i.track) != "function" && d >= _ || d >= e) return !1;
    await new Promise((x) => setTimeout(x, R));
  }
  return !0;
}
function G() {
  return r || (r = B().then((e) => (e || (r = null), e))), r;
}
async function L(e) {
  const a = await c().flags.get_variant_value(e, !1), o = typeof a == "boolean" || typeof a == "string" ? a : !1;
  return l.set(e, o), F(e, o), o;
}
async function A(e, n = 0) {
  var a;
  for (let o = 0; ; o++) {
    if (await G() && typeof ((a = c().flags) == null ? void 0 : a.get_variant_value) == "function")
      try {
        return await L(e);
      } catch (d) {
        return console.error(d), !1;
      }
    if (o >= n) return !1;
    await new Promise((i) => setTimeout(i, D));
  }
}
async function ft(e) {
  await Promise.all(
    e.filter((n) => !l.has(n)).map((n) => A(n, M))
  );
}
function yt(e) {
  const n = W(e);
  return n === void 0 ? void 0 : n === !0;
}
function W(e) {
  const n = S(e);
  return n !== null ? n : l.get(e);
}
async function kt(e) {
  const n = S(e);
  return n !== null ? n === !0 : l.has(e) ? l.get(e) === !0 : await A(e) === !0;
}
const N = "user_";
function bt(e) {
  var n, a;
  if (!e) {
    console.error(
      "@helpscout/analytics: Cannot identify user for MixPanel without a user ID"
    );
    return;
  }
  try {
    (a = (n = c()).identify) == null || a.call(
      n,
      h(`${N}${e}`)
    );
  } catch (o) {
    console.error(
      "@helpscout/analytics: Error identifying user for MixPanel",
      o
    );
  }
}
function ht() {
  var e, n;
  try {
    (n = (e = c()).reset) == null || n.call(e);
  } catch (a) {
    console.error(
      "@helpscout/analytics: Error resetting identity for MixPanel",
      a
    );
  }
}
const K = [
  "Clicked Button",
  "Clicked Copy Workflow Button",
  "Clicked Copy Workflow to Mailbox Button",
  "Clicked Link",
  'In App Tour "Next" Button Clicked',
  'In App Tour "Close" Button Clicked',
  "Signed Up"
];
class s {
  /**
   * Constructor for BaseEvent
   * @param properties - Properties for the event
   */
  constructor(n) {
    /** Event properties */
    t(this, "properties");
    this.properties = n;
  }
  /**
   * Get trackable properties. This is the properties that will be sent to the
   * tracking service. The default implementation adds the following properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   * Override this method to add additional properties.
   * @protected
   */
  getTrackableProperties() {
    return {
      ...this.properties ?? {},
      companyId: window.hsGlobal.companyId,
      memberId: K.includes(this.name) ? window.hsGlobal.memberId : void 0,
      userId: window.hsGlobal.memberId
    };
  }
  /**
   * Get the track function. This is the function that will be used to track the
   * event. The default implementation checks if the environment is a storybook
   * environment or a local environment. If it is a storybook environment, it
   * returns the console track function. If it is a local environment, it returns
   * the console track function. Otherwise, it returns the noop track function.
   * Override this method if you want to use a different tracking service or
   * strategy.
   * @protected
   */
  getAnalyticsService() {
    return c();
  }
  /**
   * Track the event. This is the function that will be called to track the event.
   * The default implementation adds the following properties to the trackable
   * properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   *
   * @returns The current instance of the event
   */
  track() {
    try {
      const n = this.getTrackableProperties();
      this.getAnalyticsService().track(this.name, n);
    } catch (n) {
      console.error("@helpscout/analytics track failed", n);
    }
    return this;
  }
}
class Y extends s {
  constructor({
    pageVisited: a,
    state: o
  }) {
    super({
      pageVisited: a ?? (typeof window < "u" ? window.location.pathname : "/"),
      ...o && { state: o }
    });
    t(this, "name", "pageVisited");
  }
}
class p extends s {
}
class $ extends p {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Button");
  }
}
class H extends p {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Link");
  }
}
class j extends p {
  constructor({
    step: a
  }) {
    var o, i;
    super({
      signUpStep: a,
      com_id: ((o = window.hsGlobal) == null ? void 0 : o.companyId) ?? "",
      usr_id: ((i = window.hsGlobal) == null ? void 0 : i.memberId) ?? ""
    });
    t(this, "name", "Signed Up");
  }
}
class J extends s {
  constructor(a) {
    super({
      currentAvailabilityStatus: a == null ? void 0 : a.currentAvailabilityStatus
    });
    t(this, "name", "accountDropdownOpened");
  }
}
class z extends s {
  constructor(a) {
    super({
      itemType: a.itemType,
      itemValue: a.itemValue
    });
    t(this, "name", "accountDropdownItemClicked");
  }
}
class X extends s {
  constructor(a) {
    super({
      currentStatus: a.currentStatus,
      intendedStatus: a.intendedStatus
    });
    t(this, "name", "availabilityToggleClicked");
  }
}
class q extends s {
  constructor(a) {
    super({
      previousStatus: a.previousStatus,
      newStatus: a.newStatus,
      success: a.success,
      errorType: a.errorType
    });
    t(this, "name", "availabilityChanged");
  }
}
class Q extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsEnabled");
  }
}
class Z extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDisabled");
  }
}
class ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDeleted");
  }
}
class ne extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsAppliedToInbox");
  }
}
class te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsReviewNotificationClicked");
  }
}
class se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserCreated");
  }
}
class ae extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserModified");
  }
}
class oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicConvoOverride");
  }
}
class ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueEnabled");
  }
}
class de extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueDisabled");
  }
}
class le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedSearch");
  }
}
class ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedReports");
  }
}
class re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedWorkflows");
  }
}
class me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedViews");
  }
}
class ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedColumns");
  }
}
class pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedColumns");
  }
}
class ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentRemovedFromColumns");
  }
}
class Ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedViews");
  }
}
class xe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedWorkflows");
  }
}
class Ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedSearch");
  }
}
class we extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedSort");
  }
}
class Se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactSentimentConversationsOpened");
  }
}
class Ae extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsArticleCreated");
  }
}
class ge extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsAiAnswersPromoClicked");
  }
}
class m extends s {
  constructor(n) {
    if (!n.inboxForwarderContext && typeof window < "u") {
      const o = window.location.pathname.includes("/settings/inbox");
      super({
        ...n,
        inboxForwarderContext: o ? "inbox-settings" : "setup-guide"
      });
    } else
      super(n);
  }
}
class fe extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderCancelClicked");
  }
}
class ye extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectChannelsClicked");
  }
}
class ke extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectDifferentEmailClicked");
  }
}
class be extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderFinishLaterClicked");
  }
}
class he extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidebarToggled");
  }
}
class Te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyListOpened");
  }
}
class Ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileOpened");
  }
}
class Oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileTabOpened");
  }
}
class Pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidepanelOpened");
  }
}
class Re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileEditSaved");
  }
}
class _e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyPropertiesUpsellClicked");
  }
}
class Me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyOverviewTimeframeChanged");
  }
}
class De extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactProfileTabOpened");
  }
}
class Ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementAdded");
  }
}
class Ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementUpdated");
  }
}
class Fe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementDeleted");
  }
}
class Be extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improveButtonClicked");
  }
}
class Ge extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementGenerated");
  }
}
class g extends s {
}
class Le extends g {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Next" Button Clicked');
  }
}
class We extends g {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Close" Button Clicked');
  }
}
class Ne extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxBlankSlateClicked");
  }
}
class Ke extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxConnectBannerClicked");
  }
}
class Ye extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxWelcomeModalClicked");
  }
}
class $e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepViewed");
  }
}
class He extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepCtaClicked");
  }
}
class je extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideHelpLinkClicked");
  }
}
class Je extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideDismissed");
  }
}
class ze extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideRestored");
  }
}
class f extends s {
}
class Xe extends f {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsIncluded");
  }
}
class qe extends f {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsExcluded");
  }
}
class v extends s {
}
class C extends s {
}
class Qe extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsMenuOpened");
  }
}
class Ze extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsAddMenuOpened");
  }
}
class en extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReset");
  }
}
class nn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReordered");
  }
}
class tn extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnAdded");
  }
}
class sn extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnRemoved");
  }
}
class an extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnHeaderClicked");
  }
}
class on extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewSorted");
  }
}
class dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalOpened");
  }
}
class ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClosed");
  }
}
class cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalSelectAllClicked");
  }
}
class rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClearAllClicked");
  }
}
class mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopied");
  }
}
class un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersEnabled");
  }
}
class pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersDisabled");
  }
}
class vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersEnabled");
  }
}
class Cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersDisabled");
  }
}
class xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersContactUsClicked");
  }
}
class En extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersManageClicked");
  }
}
class wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionAdded");
  }
}
class Sn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionRemoved");
  }
}
class An extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inAppBeaconMessageShown");
  }
}
class gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupStarted");
  }
}
class fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconContactStepCompleted");
  }
}
class yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconCustomizeStepCompleted");
  }
}
class kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSelfServiceStepCompleted");
  }
}
class bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupCompleted");
  }
}
class hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentCreated");
  }
}
class Tn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDeleted");
  }
}
class In extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentPublished");
  }
}
class On extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentTestSessionStarted");
  }
}
class Pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceAdded");
  }
}
class Rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceRemoved");
  }
}
class _n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceAdded");
  }
}
class Mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceRemoved");
  }
}
class Dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentNameChanged");
  }
}
class Vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentIdentityChanged");
  }
}
class Un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentConnectionActivated");
  }
}
class Fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepViewed");
  }
}
class Bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepCompleted");
  }
}
class Gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCancelled");
  }
}
class Ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceAdded");
  }
}
class Wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceRemoved");
  }
}
class Nn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCompleted");
  }
}
class Kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStarted");
  }
}
class Yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupNextClicked");
  }
}
class $n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupBackClicked");
  }
}
class Hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupTryItOutClicked");
  }
}
class jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupAddKnowledgeClicked");
  }
}
class Jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersSimulationStarted");
  }
}
class zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "globalBannerCtaClicked");
  }
}
class Xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailGenerated");
  }
}
class qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailAdded");
  }
}
class Qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailUpdated");
  }
}
class Zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailDeleted");
  }
}
class et extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "experienceKit");
  }
}
class nt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockFooterCtaClicked");
  }
}
class tt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockCancellationBridgeLanded");
  }
}
class st extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "showOriginalClicked");
  }
}
class at extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsViewed");
  }
}
class ot extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsSaved");
  }
}
class it extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalEnabled");
  }
}
class dt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalDisabled");
  }
}
class lt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectClicked");
  }
}
class ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectionSubmitted");
  }
}
class rt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectSetupCancelled");
  }
}
class mt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelDisconnectClicked");
  }
}
class ut extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaOnboardingViewed");
  }
}
class pt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaCreateStarted");
  }
}
class vt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyCreated");
  }
}
class Ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyToggled");
  }
}
class xt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPoliciesReordered");
  }
}
class Et extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaLearnMoreClicked");
  }
}
const E = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountDropdownItemClickedEvent: z,
  AccountDropdownOpenedEvent: J,
  AiAgentConnectionActivatedEvent: Un,
  AiAgentCreatedEvent: hn,
  AiAgentDeletedEvent: Tn,
  AiAgentDocSourceAddedEvent: Pn,
  AiAgentDocSourceRemovedEvent: Rn,
  AiAgentIdentityChangedEvent: Vn,
  AiAgentNameChangedEvent: Dn,
  AiAgentPublishedEvent: In,
  AiAgentSetupAddKnowledgeClickedEvent: jn,
  AiAgentSetupBackClickedEvent: $n,
  AiAgentSetupCancelledEvent: Gn,
  AiAgentSetupCompletedEvent: Nn,
  AiAgentSetupNextClickedEvent: Yn,
  AiAgentSetupSourceAddedEvent: Ln,
  AiAgentSetupSourceRemovedEvent: Wn,
  AiAgentSetupStartedEvent: Kn,
  AiAgentSetupStepCompletedEvent: Bn,
  AiAgentSetupStepViewedEvent: Fn,
  AiAgentSetupTryItOutClickedEvent: Hn,
  AiAgentTestSessionStartedEvent: On,
  AiAgentWebsiteSourceAddedEvent: _n,
  AiAgentWebsiteSourceRemovedEvent: Mn,
  AiAnswersDisabledEvent: pn,
  AiAnswersEnabledEvent: un,
  AiAnswersSimulationStartedEvent: Jn,
  AvailabilityChangedEvent: q,
  AvailabilityToggleClickedEvent: X,
  BeaconContactStepCompletedEvent: fn,
  BeaconCustomizeStepCompletedEvent: yn,
  BeaconSelfServiceStepCompletedEvent: kn,
  BeaconSetupCompletedEvent: bn,
  BeaconSetupStartedEvent: gn,
  ChannelConnectClickedEvent: lt,
  ChannelConnectSetupCancelledEvent: rt,
  ChannelConnectionSubmittedEvent: ct,
  ChannelDisconnectClickedEvent: mt,
  ClickedButtonEvent: $,
  ClickedLinkEvent: H,
  CompanyListOpenedEvent: Te,
  CompanyOverviewTimeframeChangedEvent: Me,
  CompanyProfileEditSavedEvent: Re,
  CompanyProfileOpenedEvent: Ie,
  CompanyProfileTabOpenedEvent: Oe,
  CompanyPropertiesUpsellClickedEvent: _e,
  CompanySidebarToggledEvent: he,
  CompanySidepanelOpenedEvent: Pe,
  ContactProfileTabOpenedEvent: De,
  ContactSentimentConversationsOpenedEvent: Se,
  CustomerPortalDisabledEvent: dt,
  CustomerPortalEnabledEvent: it,
  CustomerPortalSettingsSavedEvent: ot,
  CustomerPortalSettingsViewedEvent: at,
  DocsAiAnswersPromoClickedEvent: ge,
  DocsArticleCreatedEvent: Ae,
  ExperienceKitEvent: et,
  GlobalBannerCtaClickedEvent: zn,
  GuardrailAddedEvent: qn,
  GuardrailDeletedEvent: Zn,
  GuardrailGeneratedEvent: Xn,
  GuardrailUpdatedEvent: Qn,
  ImproveButtonClickedEvent: Be,
  ImprovementAddedEvent: Ve,
  ImprovementDeletedEvent: Fe,
  ImprovementGeneratedEvent: Ge,
  ImprovementUpdatedEvent: Ue,
  InAppBeaconMessageShownEvent: An,
  InAppTourCloseButtonClickedEvent: We,
  InAppTourNextButtonClickedEvent: Le,
  InboxAiAnswersDisabledEvent: Cn,
  InboxAiAnswersEnabledEvent: vn,
  InboxBlankSlateClickedEvent: Ne,
  InboxConnectBannerClickedEvent: Ke,
  InboxForwarderCancelClickedEvent: fe,
  InboxForwarderConnectChannelsClickedEvent: ye,
  InboxForwarderConnectDifferentEmailClickedEvent: ke,
  InboxForwarderFinishLaterClickedEvent: be,
  InboxWelcomeModalClickedEvent: Ye,
  PageVisitedEvent: Y,
  PrepaidAiAnswersContactUsClickedEvent: xn,
  PrepaidAiAnswersManageClickedEvent: En,
  RoadblockCancellationBridgeLandedEvent: tt,
  RoadblockFooterCtaClickedEvent: nt,
  SentimentRemovedFromColumnsEvent: ve,
  SentimentUsedColumnsEvent: pe,
  SentimentUsedSearchEvent: Ee,
  SentimentUsedSortEvent: we,
  SentimentUsedViewsEvent: Ce,
  SentimentUsedWorkflowsEvent: xe,
  SetupGuideDismissed: Je,
  SetupGuideHelpLinkClicked: je,
  SetupGuideRestored: ze,
  SetupGuideStepCtaClicked: He,
  SetupGuideStepViewed: $e,
  ShowOriginalClickedEvent: st,
  SignedUpEvent: j,
  SlaCreateStartedEvent: pt,
  SlaLearnMoreClickedEvent: Et,
  SlaOnboardingViewedEvent: ut,
  SlaPoliciesReorderedEvent: xt,
  SlaPolicyCreatedEvent: vt,
  SlaPolicyToggledEvent: Ct,
  ThreadReactionAddedEvent: wn,
  ThreadReactionRemovedEvent: Sn,
  TopicConvoOverrideEvent: oe,
  TopicUsedColumnsEvent: ue,
  TopicUsedReportsEvent: ce,
  TopicUsedSearchEvent: le,
  TopicUsedViewsEvent: me,
  TopicUsedWorkflowsEvent: re,
  TopicUserCreatedEvent: se,
  TopicUserModifiedEvent: ae,
  TopicValueDisabledEvent: de,
  TopicValueEnabledEvent: ie,
  TopicsAppliedToInboxEvent: ne,
  TopicsDeletedEvent: ee,
  TopicsDisabledEvent: Z,
  TopicsEnabledEvent: Q,
  TopicsReviewNotificationClickedEvent: te,
  ViewClosedConversationsExcludedEvent: qe,
  ViewClosedConversationsIncludedEvent: Xe,
  ViewColumnAddedEvent: tn,
  ViewColumnHeaderClickedEvent: an,
  ViewColumnRemovedEvent: sn,
  ViewColumnSortedEvent: on,
  ViewColumnsAddMenuOpenedEvent: Ze,
  ViewColumnsCopiedEvent: mn,
  ViewColumnsCopyModalClearAllClickedEvent: rn,
  ViewColumnsCopyModalClosedEvent: ln,
  ViewColumnsCopyModalOpenedEvent: dn,
  ViewColumnsCopyModalSelectAllClickedEvent: cn,
  ViewColumnsMenuOpenedEvent: Qe,
  ViewColumnsReorderedEvent: nn,
  ViewColumnsResetEvent: en
}, Symbol.toStringTag, { value: "Module" })), wt = (e) => {
  const n = e.replace(/Event$/, "");
  return n.length === 0 ? "" : n.charAt(0).toLowerCase() + n.slice(1);
}, St = () => {
  const e = {};
  return new Proxy(e, {
    get: (n, a) => {
      const o = Object.keys(E).find(
        (d) => wt(d) === a
      );
      if (!o)
        throw new Error(`No event found for method: ${String(a)}`);
      const i = E[o];
      return (d = {}) => new i(d).track();
    }
  });
}, Tt = St();
export {
  ft as ensureMixpanelFlagsReady,
  gt as getDistinctId,
  yt as getMixpanelFlagSync,
  W as getMixpanelVariantValueSync,
  bt as identify,
  kt as isMixpanelFlagEnabled,
  ht as resetIdentity,
  Tt as track
};
